//export const URL_BASE = "http://jucinei-002-site31.htempurl.com/api";
//export const URL_BASE = "http://pablofsilva91-001-site1.htempurl.com/api";
export const URL_BASE = "https://api.instajob.work/api";
//export const URL_BASE = "https://localhost:5001/api";
export const USER_TOKEN = 'USER_TOKEN';